import OTALogo from './OTALogo';

export default OTALogo;
